import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
const VIDEO_POPUP_CLASS = 'popup__video';
class VideoPopup {
  fancyBoxObj;
  fancyEl;

  constructor (popup, popupIndex) {
    this.popup = jQuery(popup);
    this.popupIndex = popupIndex;
    this.wrapElement();
    this.init();
  }

  wrapElement () {
    this.fancyEl = this.popup;
    const fancyURL = this.fancyEl.attr('href');
    this.fancyEl.removeAttr('href')
      .attr({
        'data-src': fancyURL,
        'data-type': 'iframe',
        'data-fancybox': `gallery-${this.popupIndex}`,
        'rel': `gallery-${this.popupIndex}`
      })
      .addClass(VIDEO_POPUP_CLASS);
  }

  init () {
    Fancybox.bind('.popup__video', {
      groupAll: false,
      baseClass: 'oxy-lightbox',
    });
  }
}
export default VideoPopup;
